<script setup lang="ts">
import type { RulesPolicyDocument } from '#layers/access';
import type { TabsItem } from '#layers/ui';
import { useI18n } from 'vue-i18n';
import { useModelUpdater } from '~/composables/use-model-updater';

const modelValue = defineModel<RulesPolicyDocument>('modelValue', { required: true });
const { createWritableComputed } = useModelUpdater(modelValue);
const { t } = useI18n();

const itemRules = createWritableComputed('itemRules');
const fieldRules = createWritableComputed('fieldRules');
const validationRules = createWritableComputed('validationRules');
const entitlements = createWritableComputed('entitlements');

const tabItems = [
	{ label: t('policy.policy_rules.title'), slot: 'policy-rules' as const },
	{ label: t('policy.entitlements.title'), slot: 'entitlements' as const },
] satisfies TabsItem[];
</script>

<template>
	<DTabs color="neutral" variant="link" :items="tabItems" :ui="{ content: 'pt-2' }">
		<template #policy-rules>
			<DFormField>
				<PolicyRules
					v-model:item-rules="itemRules"
					v-model:field-rules="fieldRules"
					v-model:validation-rules="validationRules"
				/>
			</DFormField>
		</template>
		<template #entitlements>
			<PolicyEntitlements v-model="entitlements" />
		</template>
	</DTabs>
</template>
